import { ReactNode } from 'react';
import { Button, ButtonsContainer, Modal } from '@forma/forma-ui-kit';

import { ITemplateSide } from 'interfaces/templates.interface';

import styles from './select-side-modal.module.css';

interface SelectSideModalProps {
  open: boolean,
  onClose: () => void,
  title: ReactNode,
  sides: ITemplateSide[],
  onSelectSide: (sideId: string) => void,
}

const SelectSideModal = ({ open, onClose, title, sides, onSelectSide }: SelectSideModalProps) => {
  return (
    <Modal
      size="small"
      open={open}
      title={title}
      onClose={onClose}
    >
      <ButtonsContainer className={styles.buttons}>
        {sides.map(({ id, name }) => (
          <Button
            viewStyle="tertiary"
            onClick={() => onSelectSide(id)}
            fullWidth
            key={id}
          >
            {name}
          </Button>
        ))}
      </ButtonsContainer>
    </Modal>
  );
};

export default SelectSideModal;
